module.exports = __webpack_public_path__ + "static/blog47-0b0622010e576e594d6814a9f01c416b.png";